import { useState, useEffect, useContext } from 'react';
import { PaxContext } from '../../utils/context/checkoutContext';

interface LocationData {
  lat: number;
  lng: number;
  address: string;
  city: string;
  country: string;
}

export default function LocationMessage() {
  const [location, setLocation] = useState<LocationData | null>(null);
  const { updateCurrency }: any = useContext(PaxContext);
  useEffect(() => {
    localStorage.removeItem('currencySetByLocation');
  }, []);
  useEffect(() => {
    if (!navigator.geolocation) {
      return;
    }

    const isCurrencySet = localStorage.getItem('currencySetByLocation');
    if (isCurrencySet === 'true') {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async position => {
        try {
          const { latitude, longitude } = position.coords;

          const res = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
          );
          const data = await res.json();

          const city = data.city || '';
          const country = data.countryName || '';
          const address =
            city || country ? `${city}, ${country}` : 'Location not available';
          setLocation({
            lat: latitude,
            lng: longitude,
            address,
            city,
            country
          });

          if (country.toLowerCase() === 'canada') {
            updateCurrency('CAD');
            localStorage.setItem('currencySetByLocation', 'true');
          } else {
            updateCurrency('USD');
            localStorage.setItem('currencySetByLocation', 'true');
          }
        } catch (error) {
          console.error('Reverse geocoding failed:', error);
          setLocation(null);
          updateCurrency('USD');
          localStorage.setItem('currencySetByLocation', 'true');
        }
      },
      error => {
        console.error('Geolocation error:', error);
        setLocation(null);
        updateCurrency('USD');
        localStorage.setItem('currencySetByLocation', 'true');
      }
    );
  }, [updateCurrency]);

  return null;
}
